export type DurationAndCostDTO = {
  duration: string | null;
  cost: number | null;
};

export const defaultDurationAndCost = {
  duration: null,
  cost: null,
};
